// ── PayrollSettings — 매장별 급여 설정 ───────────────────
import React from 'react';
import { DEFAULT_PAYROLL_SETTINGS } from '../../utils/payroll';

const KOR_DAYS = ['일', '월', '화', '수', '목', '금', '토'];

export default function PayrollSettings({ settings = {}, onChange }) {
  const v = { ...DEFAULT_PAYROLL_SETTINGS, ...settings };
  const set = (k, val) => onChange({ ...v, [k]: val });

  const inp = {
    width: '100%', padding: '8px 10px', border: '1px solid #d1d5db',
    borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box',
  };

  return (
    <div style={{ background: '#fff', borderRadius: '10px', padding: '20px',
                  border: '1px solid #e5e7eb' }}>
      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#18181B', margin: '0 0 16px' }}>
        ⚙️ 매장 급여 설정
      </h3>

      <Field
        label="5인 이상 사업장"
        desc="체크 시 연장근무·야간근무·휴일근무에 1.5배 가산수당 의무 적용"
      >
        <Toggle checked={v.isOver5Employees} onChange={x => set('isOver5Employees', x)} />
      </Field>

      <Field label="주휴수당 자동 계산" desc="주 15시간 이상 + 만근 시 1일치 추가 지급">
        <Toggle checked={v.weeklyHolidayEnabled} onChange={x => set('weeklyHolidayEnabled', x)} />
      </Field>

      <Field label="주휴일">
        <select value={v.weeklyHolidayDay} onChange={e => set('weeklyHolidayDay', Number(e.target.value))} style={inp}>
          {KOR_DAYS.map((d, i) => <option key={i} value={i}>{d}요일</option>)}
        </select>
      </Field>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <Field label="야간근무 시작" desc="기본 22:00">
          <input type="time" value={v.nightStart} onChange={e => set('nightStart', e.target.value)} style={inp} />
        </Field>
        <Field label="야간근무 종료" desc="기본 06:00">
          <input type="time" value={v.nightEnd} onChange={e => set('nightEnd', e.target.value)} style={inp} />
        </Field>
      </div>

      <Field label="급여 지급일" desc="매월 며칠에 급여 지급">
        <input type="number" value={v.payDay} min="1" max="31"
          onChange={e => set('payDay', Number(e.target.value) || 25)}
          style={{ ...inp, width: '100px' }} />
        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#6b7280' }}>일</span>
      </Field>

      <div style={{ background: '#F4F4F5', border: '1px solid #fde68a', borderRadius: '8px',
                    padding: '12px 14px', marginTop: '16px', fontSize: '12px', color: '#52525B' }}>
        <strong>💡 참고</strong><br />
        4대보험 요율과 근로소득세 간이세액은 2025년 기준입니다. 매년 변경되므로 정확한 신고 시 세무사 또는 4대보험 공단 자료를 다시 확인하세요.
      </div>
    </div>
  );
}

function Field({ label, desc, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <div style={{ fontSize: '13px', fontWeight: '700', color: '#374151' }}>{label}</div>
      {desc && <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px', marginBottom: '6px' }}>{desc}</div>}
      <div style={{ marginTop: desc ? 0 : '6px' }}>{children}</div>
    </div>
  );
}

function Toggle({ checked, onChange }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px',
                    fontSize: '13px', cursor: 'pointer' }}>
      <span style={{
        width: '36px', height: '20px', borderRadius: '999px', position: 'relative',
        background: checked ? '#FF6F0F' : '#d1d5db',
        transition: 'background 0.15s',
      }}>
        <span style={{
          position: 'absolute', top: '2px', left: checked ? '18px' : '2px',
          width: '16px', height: '16px', borderRadius: '50%', background: '#fff',
          transition: 'left 0.15s',
        }} />
      </span>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}
        style={{ display: 'none' }} />
      <span style={{ color: checked ? '#FF6F0F' : '#6b7280', fontWeight: '600' }}>
        {checked ? 'ON' : 'OFF'}
      </span>
    </label>
  );
}
